import { useProjects } from '@/features/end-of-lease/api';
import { ProjectDashboard } from '@/features/end-of-lease/projects-dashboard';
import { ProjectType } from '@/features/end-of-lease/types';
import { createFileRoute } from '@tanstack/react-router';

import { validateFilterSearch } from '@/lib/filterSearchParams';

export const Route = createFileRoute('/lease/')({
    component: LeaseIndexPage,
    validateSearch: validateFilterSearch,
});

function LeaseIndexPage() {
    const { data: projects } = useProjects({
        projectType: ProjectType.EndOfLease,
    });

    return <ProjectDashboard projects={projects || []} />;
}
